export default __webpack_public_path__ + "static/media/validateEcardOTP.ef77afdf.png";